
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import React from "react";
import { GetStaticProps } from "next";

import { BlogIndex } from "@/containers/Blog/BlogIndex";
import { getBlogPage, IBlogPage } from "@/services/wordpress";

interface IProps {
  blogPage: IBlogPage;
}

const BlogIndexPage: React.FC<IProps> = ({ blogPage }) => (
  <BlogIndex blogPage={blogPage} />
);

 const _getStaticProps: GetStaticProps<IProps> = async () => {
  const blogPage = await getBlogPage(1);

  return {
    props: { blogPage },
    revalidate: 3600,
  };
};

export default BlogIndexPage;


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        let res = _getStaticProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/blog/index',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  